import { bioCreateUser, onDeleteUser } from "../../db/BioStar/APIs";

export const onSocketAction = async (res) => {
    try {
        const { data, type, serverId } = res;
        const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId;
        //!res.centerId when action is delete, actionType for dollar prices same on all centers
        if ((data.centerId || res.centerId) === currentCenterId && serverId === 'wow_towers') {
            await onDispatchAction({ data, type })
        }
    } catch (e) {
        throw e
    }
};

const onDispatchAction = async ({
    data,
    type,
}) => {
    try {
        if (type === 0) {
            await bioCreateUser(data, true);
        }
        else if (type === 1) {
            await onDeleteUser(data);
        }
    } catch (e) {
        throw e
    }
};